import styled from 'styled-components';
import SecondaryButton from '@carvana/showroom-forms/Button/Secondary';
import { LinkWithNativeEvents } from '../_common/link/link';

const CarvanaCareCardWrapper = styled.div`
  max-width: 912px;
  background: #ffffff;
  border: 1px solid #d9dde9;
  box-sizing: border-box;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  border-radius: 8px;
  margin: 0 auto;
  overflow: hidden;

  @media (max-width: 376px) {
    & [data-testid='header-title'] {
      align-items: flex-start;
    }
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
  }
`;

const Content = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 24px;

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-bottom: 0;
  }
`;

const Button = styled(SecondaryButton)`
  margin: 0;
  min-height: 40px;
  word-break: break-word;
  padding: 0 24px;
  min-width: auto !important;

  @media (max-width: ${(props) => props.theme.breakpoint.md}px) {
    width: 100%;
    min-width: auto;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    min-width: 200px !important;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1rem;
`;

const BoldTitle = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  display: flex;
  flex-wrap: wrap;
`;

const BodyTitle = styled.div`
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  line-height: 26px;
`;

const AnchorElement = styled(LinkWithNativeEvents)`
  background: transparent;
  border-color: transparent;
  text-decoration: underline;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  padding: 0;
  margin: 0;
  color: var(--cvna-color-blue-2);
  text-decoration: underline;
  display: inline-block;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }

  &:focus {
    border-color: transparent;
    outline-color: transparent;
  }
`;

export { CarvanaCareCardWrapper, ContentWrapper, Content, Button, ButtonWrapper, BoldTitle, BodyTitle, AnchorElement };
